import React from "react";
import {MainContentWrapper, Header, PageHeading} from 'apm/components/common';

export default function ComingSoon() {
    return (
        <>
            <Header/>
            <MainContentWrapper>
                <PageHeading title='Coming Soon'/>
            </MainContentWrapper>
        </>
    )
}